<template>
  <div class="filter-container">
    <div class="card col-12 p-0">
      <div class="card-body">
        <div class="actions d-flex flex-wrap flex-auto justify-content-center tablenav">
          <DatePicker v-model="query.date" range multi-calendars format="YYYY-MM-DD" class="m-1 date-picker-left" placeholder="Date Range" style="max-width: 250px" />
          <Select class="m-1" source="sale-account/search" placeholder="Sale Account" v-model="query.account_id"></Select>
          <Select class="m-1" source="user/search" type="auto" field="order.user_read" placeholder="Seller" v-model="query.user_id"></Select>
          <button class="m-1 btn btn-light" @click.prevent="submit">Search</button>
        </div>
      </div>
    </div>

    <div class="card main-card">
      <div class="no-gutters row">
        <template v-for="(statusObject, status, index) in listStatus" :key="status">
          <div v-if="total[`status_${status}`]" class="col-12 col-md-6 col-lg-3">
            <div class="widget-content">
              <div class="widget-content-wrapper">
                <div class="widget-content-left">
                  <div class="widget-heading">{{ statusObject.label }}</div>
                  <div class="widget-subheading" style="cursor: default">
                    <small class="d-block">
                      <span class="has-tip" data-title="Sale Price" v-html="getPrices(total[`status_${status}`].sale_price)"></span>
                    </small>
                    <small class="d-block">
                      <span class="has-tip" data-title="Purchase Price" v-html="getPrices(total[`status_${status}`].purchase_price)"></span>
                    </small>
                  </div>
                </div>
                <div class="widget-content-right">
                  <div :class="`widget-numbers ${styles[index % styles.length].text}`">
                    {{ statusNumber(total[`status_${status}`]) }}
                  </div>
                </div>
              </div>
              <div class="widget-progress-wrapper">
                <div class="progress-bar-sm progress-bar-animated-alt progress">
                  <div :class="`progress-bar ${styles[index % styles.length].progressbar}`" :style="`width:${statusPercent(total[`status_${status}`])}%`"></div>
                </div>
                <div class="progress-sub-label">
                  <div class="sub-label-left">0%</div>
                  <div class="sub-label-right">100%</div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import DatePicker from '@/components/DatePicker.vue'
import moment from 'moment'
export default {
  components: {
    DatePicker
  },
  data() {
    return {
      query: {
        date: [moment(new Date()).format('YYYY-MM-DD'), moment(new Date()).format('YYYY-MM-DD')],
        account_id: '',
        user_id: ''
      },
      totalNumber: null,
      styles: [
        {
          text: 'text-warning',
          progressbar: 'bg-warning'
        },
        {
          text: 'text-danger',
          progressbar: 'bg-danger'
        },
        {
          text: 'text-primary',
          progressbar: 'bg-primary'
        },
        {
          text: 'text-success',
          progressbar: 'bg-success'
        }
      ]
    }
  },
  computed: {
    extraAttributes() {
      return this.config?.extraAttributes || {}
    },
    currency() {
      let currency = Object.assign({}, this.extraAttributes?.currency || {})
      currency.purchase = Object.assign({}, currency?.purchase || {}, {
        '': {
          label: ''
        }
      })
      return currency
    },
    listStatus() {
      return Object.fromEntries(
        Object.entries(Object.assign({}, this.extraAttributes.status)).sort(([, a], [, b]) => {
          return (a.priority || 10) - (b.priority || 10)
        })
      )
    },
    total() {
      return Object.assign({}, this.extraAttributes.all || {})
    }
  },
  methods: {
    statusNumber(item) {
      return item.number || 0
    },
    statusPercent(item) {
      return Math.round((this.statusNumber(item) * 100) / this.statusNumber(this.total.status_total))
    },
    getPrices(items) {
      let prices = []
      if (_.isObjectLike(items)) {
        Object.entries(items).forEach(([currency, price]) => {
          if (price > 0) {
            prices.push(`${parseFloat(price).toFixed(2)}${this.currency.sale[currency] != undefined ? this.currency.sale[currency].label : currency}`)
          }
        })
      }
      return prices.join(' - ')
    },
    submit() {
      this.query.search = ''
      this.$emit('change-filters', this.query, { refresh: true, goToFirst: true })
    }
  },
  props: {
    config: Object
  }
}
</script>
<style lang="scss">
.page-order-statistic-detail {
  .filter-container {
    > .card {
      margin-bottom: 20px;
    }
  }
}
</style>
